export enum ValueType {
    Text = 'Text',
    LongText = 'LongText',
    Option = 'Option',
    Number = 'Number',
    Date = 'Date',
    Disabled = 'Disabled',
    Boolean = 'Boolean',
    Group = 'Group'
}
